import { withInstall } from "../utils/index.mjs";
import _BackTop from "./BackTop.mjs";
const BackTop = withInstall(_BackTop);
var stdin_default = BackTop;
import { backTopProps } from "./BackTop.mjs";
export {
  BackTop,
  backTopProps,
  stdin_default as default
};
